import "apps/pathways/styles/components/resume-builder.scss";
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'library/util/core-router';
import Linkedin from 'library/components/linkedin';
import ResumeUpload from 'library/components/resume-upload';
import { resolve, set } from 'library/helpers/path-resolver';
import Ajax from 'library/util/ajax';
import SavingButton from 'library/components/saving-button';
import Cookie from 'library/util/cookies';
import Cache from 'library/util/cache';
import DeepMerge from 'library/util/deepmerge';
import DeepEqual from 'deep-equal';
import ExperientialService from 'apps/pathways/services/experiential';

import PersonalInformation from 'apps/pathways/components/resume-builder/personal';
import ContactInformation from 'apps/pathways/components/resume-builder/contact';
import SocialInformation from 'apps/pathways/components/resume-builder/social';
import MilitaryExperience from 'apps/pathways/components/resume-builder/military';
import WorkExperience from 'apps/pathways/components/resume-builder/work';
import Education from 'apps/pathways/components/resume-builder/education';
import Certifications from 'apps/pathways/components/resume-builder/certifications';
import Skills from 'apps/pathways/components/resume-builder/skills';
import Languages from 'apps/pathways/components/resume-builder/languages';

const ResumeBackgroundSvg = ({ first='Test', last='User' }) => (
  <div className="resume-builder-resume-background">
    <svg width="612px" height="792px" viewBox="0 0 612 792" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <circle fill="#4CC0B3" cx="64.5" cy="67.5" r="37.5"></circle>
        <text textAnchor="middle" x="64.5" y="82" fontFamily="Lato-Medium, Lato" fontSize="36" fontWeight="400" fill="#FFFFFF">
          {first[0]}{last[0]}
        </text>
        <text fontFamily="Lato-Medium, Lato" fontSize="24" fontWeight="400" fill="#797979">
          <tspan x="116" y="77">{first} {last}</tspan>
        </text>
        <g transform="translate(27.000000, 134.000000)">
          <path d="M0,0 L89,0 L89,19 L0,19 L0,0 Z M104,0 L397,0 L397,19 L104,19 L104,0 Z M0,29 L89,29 L89,48 L0,48 L0,29 Z M104,29 L397,29 L397,48 L104,48 L104,29 Z M0,58 L89,58 L89,77 L0,77 L0,58 Z M104,58 L397,58 L397,77 L104,77 L104,58 Z M0,87 L89,87 L89,106 L0,106 L0,87 Z M104,87 L397,87 L397,106 L104,106 L104,87 Z" fill="#EFEFEF"></path>
          <path d="M0,174 L89,174 L89,193 L0,193 L0,174 Z M104,174 L397,174 L397,193 L104,193 L104,174 Z M0,203 L89,203 L89,222 L0,222 L0,203 Z M104,203 L397,203 L397,222 L104,222 L104,203 Z M0,232 L89,232 L89,251 L0,251 L0,232 Z M104,232 L397,232 L397,251 L104,251 L104,232 Z M0,261 L89,261 L89,280 L0,280 L0,261 Z M104,261 L397,261 L397,280 L104,280 L104,261 Z" fill="#EFEFEF"></path>
          <path d="M0,348 L89,348 L89,367 L0,367 L0,348 Z M104,348 L397,348 L397,367 L104,367 L104,348 Z M0,377 L89,377 L89,396 L0,396 L0,377 Z M104,377 L397,377 L397,396 L104,396 L104,377 Z M0,406 L89,406 L89,425 L0,425 L0,406 Z M104,406 L397,406 L397,425 L104,425 L104,406 Z M0,435 L89,435 L89,454 L0,454 L0,435 Z M104,435 L397,435 L397,454 L104,454 L104,435 Z" fill="#EFEFEF"></path>
          <path d="M418.5,0.5 L418.5,454.5" stroke="#EFEFEF" strokeLinecap="square"></path>
          <path d="M442,0 L558,0 L558,19 L442,19 L442,0 Z M442,29 L558,29 L558,48 L442,48 L442,29 Z M442,58 L558,58 L558,77 L442,77 L442,58 Z M442,87 L558,87 L558,106 L442,106 L442,87 Z M442,116 L558,116 L558,135 L442,135 L442,116 Z M442,145 L558,145 L558,164 L442,164 L442,145 Z M442,174 L558,174 L558,193 L442,193 L442,174 Z M442,203 L558,203 L558,222 L442,222 L442,203 Z M442,232 L558,232 L558,251 L442,251 L442,232 Z M442,261 L558,261 L558,280 L442,280 L442,261 Z M442,290 L558,290 L558,309 L442,309 L442,290 Z M442,319 L558,319 L558,338 L442,338 L442,319 Z M442,348 L558,348 L558,367 L442,367 L442,348 Z M442,377 L558,377 L558,396 L442,396 L442,377 Z M442,406 L558,406 L558,425 L442,425 L442,406 Z M442,435 L558,435 L558,454 L442,454 L442,435 Z" fill="#EFEFEF"></path>
        </g>
      </g>
    </svg>
  </div>
);

class ResumeBuilder extends React.Component {
  static propTypes = {
    initial_data: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    saving: PropTypes.bool,
    onComplete: PropTypes.func
  }

  static defaultProps = {
    onComplete: ()=>{}
  }

  state = {
    data: {
      has_work_histories: false,
      has_military_histories: false,
      has_education_histories: false
    }
  }

  componentWillMount() {
    this.setState({
      data: this.props.initial_data
    }, this.loadFromCache);
  }

  loadFromCache = async () => {
    const value = await Cache.get('experiential', 'pairin-pathways');

    if (value && !DeepEqual(value.data, this.state.data) && confirm('We saved your changes! Would you like to continue where you left off?')) {
      this.setState({
        data: value.data
      });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.props.onComplete(this.state.data);
  }

  updateData = (name, value) => {
    this.setState((nextState) => {
      nextState.data = set(nextState.data, name, value, true, '.');
      return nextState;
    }, this.updateCache);
  }

  handleChange = ({ target }) => {
    let { value, name, type } = target;

    if (['radio', 'checkbox'].indexOf(type) > -1) {
      value = !resolve(this.state.data, name, false, '.');
    }

    this.updateData(name, value);
  };

  updateCache = async () => {
    const { data } = this.state;
    await Cache.set('experiential', {
      data: data
    }, 'pairin-pathways');
  }

  handleImport = (e) => {
    const resumes = e.target.value;
    let data = {...this.state.data};

    for (let i = 0; i < resumes.length; i++) {
      data = DeepMerge(data, resumes[i]);
    }

    alert(`We've parsed your resume but some information may still be incomplete. Please review all sections to make sure your information is correct.`);

    this.setState({
      data: ExperientialService.fromData(data).data
    }, this.updateCache);
  }

  preventEnterSubmit = (e) => {
    if (e.which===13&&e.target.nodeName!=='TEXTAREA') {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }

  render() {
    const { saving, user } = this.props;
    const { data } = this.state;

    return (
      <form onKeyDown={this.preventEnterSubmit} onSubmit={this.handleSubmit} className="resume-builder" disabled={saving}>
        <section className="signup-step-sticky">
          <SavingButton saving={saving} type="submit">Save & Continue</SavingButton>
        </section>

        <div className="resume-builder-resume">
          <h1>Upload Your Résumé</h1>
          <p>Upload your résumé and PAIRIN will automatically fill in the experience section for you.</p>
          <ResumeUpload multiple={true} onChange={this.handleImport} />
        </div>

        <div className="resume-builder-section-header">
          <h1>Experience and Education</h1>
          <p>Including your Experience and Education helps us identify gaps and matches to hundreds of jobs as we chart a pathway to your goal career.  We’ll also use this information when we create a résumé for you later.</p>
        </div>

        <WorkExperience handleChange={this.handleChange} data={data} />
        <MilitaryExperience handleChange={this.handleChange} data={data} />
        <Education handleChange={this.handleChange} data={data} />

        <div className="resume-builder-section-header">
          <h1>Additional Skills and Information</h1>
          <p>Help us tailor career recommendations based on your special set of skills. You can always update this information as you add more skills. Including your certifications, languages you speak, and other information will help us create a great résumé for you.</p>
        </div>

        <Certifications handleChange={this.handleChange} data={data} />
        <Skills handleChange={this.handleChange} data={data} />
        <Languages handleChange={this.handleChange} data={data} />
        <SocialInformation handleChange={this.handleChange} data={data} />
        <ContactInformation handleChange={this.handleChange} data={data} />
      </form>
    );
  }
}

export default withRouter(ResumeBuilder);
